import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { SurveyCreatePage } from '@/features/surveys/pages/SurveyCreatePage';

export const Route = createFileRoute('/_auth/feedback/surveys/new')({
  component: () => (
    <ErrorBoundary moduleName="Create Survey">
      <Suspense fallback={<PageLoader />}>
        <SurveyCreatePage />
      </Suspense>
    </ErrorBoundary>
  ),
});
